export default {"src":"/_next/static/media/Slovakia.76b798b6.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};